<payee-popup
  width="560px"
  [onCancel]="onCancel"
>
  <ng-template #payeePopupTitleTemplate>
    <h1 class="title">{{ dialogData?.transition_label }}</h1>
  </ng-template>

  <div class="dialog-content">
    @if (dialogData) {
      <payee-form-field width="max">
        <span payee-label>{{ dialogData.original_request_label }}</span>
        <div class="original-message">{{ dialogData.original_message }}</div>
      </payee-form-field>
    }

    <form [formGroup]="form">
      <payee-workflow-provided-media [transitionWithDialog]="data"></payee-workflow-provided-media>

      <payee-form-field width="max">
        <span payee-label>{{ dialogData?.response_label }}</span>
        <textarea
          payee-input
          formControlName="message"
          rows="6"
        ></textarea>
        @if (form.get("message")?.hasError("required") && form.get("message")?.touched) {
          <span payee-error>
            {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
          </span>
        }
      </payee-form-field>

      <div class="subtitle">Fájlok feltöltése (opcionális)</div>

      <payee-form-field width="max">
        <payee-dropzone
          width="max"
          heading="Fájl feltöltése"
          (dropped)="onDrop($event)"
        ></payee-dropzone>
      </payee-form-field>

      <div class="files-list">
        @for (file of files.value; track $index; let fileIndex = $index) {
          <div class="file-item flex vcenter">
            <div class="file-status">
              <payee-icon name="checkmark-darker-green-circle"></payee-icon>
            </div>
            <div class="file-name">{{ file.name }}</div>
            <button
              payee-icon-button
              color="white"
              class="file-delete-button"
              (click)="removeFile(fileIndex)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          </div>
        }
      </div>
    </form>
  </div>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="loading"
      [loading]="loading"
      (click)="onSubmit()"
    >
      {{ dialogData?.submit_label }}
    </button>
  </ng-template>
</payee-popup>
